import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'

// OBTENER POSICIONES
export const getPosiciones = async () => {
  const response = await PrivateInterceptor('Payrolls/Posiciones', 'GET');
  return response;
}

// OBTENER POSICIONES ACTIVAS
export const getPosicionesAct = async () => {
  const response = await PrivateInterceptor('Payrolls/Posiciones/PosicionesAct', 'GET');
  return response;
}


export const getPosicionesPorId = async (idPosiciones) => {
  const response = await PrivateInterceptor('Payrolls/Posiciones/posicionesPorId', 'POST', {idPosiciones});
  return response;
}

export const postChangeEstado = async (data) => {
  const result = await PrivateInterceptor(`Payrolls/Posiciones/chageEstado`, 'POST', data);
  return result;
}

export const GuardarPosicion = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Posiciones/GuardarPosicion", "POST", {Datos});
  return respuesta;
};

// GUARDAR POSICION
export const EditarPosicion = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Posiciones/EditarPosicion", "POST", {Datos});
  return respuesta;
};

export const getTurnos = async () => {
  const response = await PrivateInterceptor('Payrolls/Posiciones/getTurnos', 'GET');
  return response;
}

export const getNominas = async () => {
  const response = await PrivateInterceptor('Payrolls/Posiciones/getNominas', 'GET');
  return response;
}

export const getBeneficios = async () => {
  const response = await PrivateInterceptor('Payrolls/Posiciones/getBeneficios', 'GET');
  return response;
}

export const getResponsabilidades = async (IdPosicion) => {
  const response = await PrivateInterceptor('Payrolls/Posiciones/getResponsabilidades', 'POST', {IdPosicion});
  return response;
}

export const getHabilidades = async (IdPosicion) => {
  const response = await PrivateInterceptor('Payrolls/Posiciones/getHabilidades', 'POST', {IdPosicion});
  return response;
}

export const getBeneficiosPorId = async (IdBeneficios) => {
  const response = await PrivateInterceptor('Payrolls/Posiciones/getBeneficiosPorId', 'POST',{IdBeneficios});
  return response;
}

export const EliminarResponsabilidad = async (IdResponsabilidad) => {
  const response = await PrivateInterceptor('Payrolls/Posiciones/EliminarResponsabilidad', 'POST',{IdResponsabilidad});
  return response;
}

export const EliminarHabilidad = async (IdHabilidad) => {
  const response = await PrivateInterceptor('Payrolls/Posiciones/EliminarHabilidad', 'POST',{IdHabilidad});
  return response;
}

export const obtenerCodigo = async () => {
  const response = await PrivateInterceptor('Payrolls/Posiciones/ObtenerSiguienteCodigo', 'GET');
  return response;
}